import script from "./RequiredConsentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RequiredConsentModal.vue?vue&type=script&setup=true&lang=js"

import "./RequiredConsentModal.vue?vue&type=style&index=0&id=1f6bdeb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f6bdeb6"]])

export default __exports__